export default "__VITE_ASSET__56e80de6__"